import {Injectable, signal} from '@angular/core';
import {Customer} from "../../customer/models/customer";
import {Loan} from "../../loan/models/loan";

@Injectable({
  providedIn: 'root'
})
export class SharedStateService {
  isCustomerLogged = signal<boolean>(false);
  customer = signal<Customer | null>(null);
  customerCurrentLoan = signal<Loan | null>(null);

  triggerLogoutActions(): void {
    this.isCustomerLogged.set(false);
    this.customer.set(null);
    this.customerCurrentLoan.set(null);
  }
}
